import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import * as moment from 'moment';

@Injectable()
export class DateService {
    bindableDatePartsToMoment(d: Date, offset: number): Moment {
        // Combines the YMD/HMS values from a date, from a UI control
        // (which default to the current browser offset), with a specified offset.
        // e.g. Take 15:20 from a browser date (may be +10) and stick it in Auckland 15:20+13.
        const m = moment([
            // use the YMD/HMS from the date
            d.getFullYear(),
            d.getMonth(),
            d.getDate(),
            d.getHours(),
            d.getMinutes(),
            d.getSeconds(),
            d.getMilliseconds()
        ]).utcOffset(offset, true); // use the offset, but don't adjust the time
        return m;
    }

    // We want to "snap" requests to the closest minute (as the UI/UX only allows selecting in minute increments).
    momentToClosestMinute(timestamp: Moment): Moment {
        const closest = timestamp.clone().add(30, 'second').startOf('minute');
        return closest;
    }

    momentPartsToBindableDate(m: Moment): Date {
        // Put the YMD/HMS values into Date objects, for binding to UI controls,
        // although those objects will default to the local browser offset.
        // e.g. Taking Auckland 15:20+13 and stick it into a Date object as 15:20 in the browser offset
        const d = new Date(
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        );
        return d;
    }
}
